import { render, staticRenderFns } from "./ModalRichmediaBox.vue?vue&type=template&id=a103bb24&scoped=true&"
import script from "./ModalRichmediaBox.vue?vue&type=script&lang=js&"
export * from "./ModalRichmediaBox.vue?vue&type=script&lang=js&"
import style0 from "./ModalRichmediaBox.vue?vue&type=style&index=0&id=a103bb24&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a103bb24",
  null
  
)

export default component.exports